'use strict'

let watermark = {}

let setWatermark = (str1, str2) => {
  let id = '1.23452384164.123412415'

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas')
  let width = window.parseInt(document.body.clientWidth)
  let canvasWidth = width / window.parseInt(width / 220)
  can.width = canvasWidth
  can.height = 180

  let cans = can.getContext('2d')
  cans.rotate((-14 * Math.PI) / 180)
  cans.font = '14px Vedana'
  cans.fillStyle = 'rgba(200, 200, 200, 0.20)'
  cans.textAlign = 'center'
  cans.textBaseline = 'middle'
  cans.fillText(str1, can.width / 2, can.height / 2)
  cans.fillText(str2, can.width / 3, can.height / 1)

  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = '100%'
  div.style.height = '100%'
  div.style.background =
    'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}

// 该方法只允许调用一次
watermark.set = (str1, str2) => {
  let id = setWatermark(str1, str2)
  setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(str1, str2)
    }
  }, 500)
  window.onresize = () => {
    setWatermark(str1, str2)
  }
}

export default watermark
